import script from "./AddPendencyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPendencyModal.vue?vue&type=script&setup=true&lang=js"

import "./AddPendencyModal.vue?vue&type=style&index=0&id=b38a71b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b38a71b8"]])

export default __exports__